import { AdminManagement } from "~/components/admin/admin-management";

export const AdminManagementScreen = () => {
  return <AdminManagement />;
}; 